import { createSelector } from 'reselect'

type User = { id: number; first_name?: string; last_name?: string }

const noUsers: User[] = []

export const getUsers = createSelector(
  state => state.orm.users?.items,
  (users): User[] => (users ? Object.values(users) : noUsers),
)
